export default "__VITE_ASSET__b01cd5fc__"